import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mock-functionbar',
  templateUrl: './functionbar.component.html',
  styleUrls: ['./functionbar.component.scss']
})
export class FunctionbarComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }
}
